@import "../scss/mixins";
@import "../scss/extends";
@import "@stylesheets/variables.scss";
@import "../scss/breakpoints";

$blue-10: #0A1F44;

.modal-outer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - env(safe-area-inset-bottom));
  background-color: rgba(0, 0, 0, 0.32);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;

  &.prompt {
    z-index: 100;
  }

  .modal-container.social-media-modal {
    .modal-content {
      padding: 32px;
    }

    @include breakpoint(desktop) {
      .modal-content {
        max-width: fit-content;
        min-width: fit-content;
      }
    }

    .edit-modal-inner {
      display: grid;
      gap: 24px;
    }
  }

  .modal-container.report-review {
    height: unset;
    width: unset;
    top: unset;
    margin: 10px;

    .modal-content.report-review {
      height: max-content;
    }
  }

  .modal-container.remove-prompt {
    height: unset;
    width: unset;
    top: unset;
    margin: 10px;

    .modal-content.remove-prompt {
      height: unset !important;
      padding: 32px;
      display: flex;
      align-items: center;
      flex-direction: column;
      text-align: center;

      @include breakpoint(desktop) {
        min-width: 625px;
      }

      .button-container {
        width: 100%;
        display: flex;
        gap: 16px;
        justify-content: center;
        flex-direction: column;

        button {
          width: 100%;
        }

        @include breakpoint(desktop) {
          flex-direction: row;

          button {
            width: 270px;
            height: 40px;
          }
        }
      }
    }
  }

  .modal-container {
    background-color: white;
    border-radius: 8px;
    position: fixed;
    outline: none;
    overflow: hidden;
    top: 0;
    width: 100%;
    height: 100%;

    @include breakpoint(desktop) {
      width: unset;
      height: unset;
      top: 10vh;
    }

    h1 {
      font-family: Lato;
      font-size: 16px;
      font-weight: bold;
      margin-left: 24px;
    }

    .modal-close-button {
      margin-right: 32px;
      outline: none;
      background: transparent;

      &:before {
        @include times(18px, $gray-500, 300);
      }
    }

    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid rgba(10, 31, 68, 0.08);
      height: 64px;

      .headline-3 {
        padding-left: 32px;
      }
    }

    .modal-content {
      min-width: 100%;
      margin: 0;
      overflow: auto;
      padding: 24px;

      @include breakpoint(desktop) {
        max-width: 820px;
        min-width: 820px;
      }

      &.no-header {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }

      &.no-footer {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      &.report-review {
        min-width: 512px;

        .input-field, .button-container {
          margin-left: 0;
          margin-right: 0;
          width: 100%;
        }

        .modal-button-container {
          display: flex;
          justify-content: flex-end;

          button:not(:first-child) {
            margin-left: 10px;
          }
        }
      }

      &.prompt-delete {
        display: flex;
        align-items: center;
        flex-direction: column;
        min-width: 720px;

        .button-container {
          display: flex;
          justify-content: space-around;
          width: 100%;

          .profile-default-button {
            width: 200px;
          }
        }
      }

      &.prompt-delete {
        h1 {
          margin-top: 0px;
        }

        h2 {
          margin-bottom: 20px;
        }
      }

      .circle-exclamation::after {
        @include circle-exclamation(80px, $helper-yellow, 300);
      }

      .crop-preview-text {
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        color: white;
        text-align: center;
        line-height: 1;
        text-align: center;
        letter-spacing: 0.5px;
        margin-bottom: 11px;
      }
    }

    .modal-loading {
      width: 100%;
      min-height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:after {
        @include spinner-1(48px, $blue-10);
      }
    }

    .modal-footer {
      display: flex;
      flex-flow: row-reverse;
      align-items: center;
      padding-right: 24px;
      padding-left: 24px;
      height: 80px;
      border-top:  1px solid rgba(10, 31, 68, 0.08);

      .modal-footer-inner {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: space-between;

        .footer-left {
          margin-right: 10px;
          margin-left: 10px;
        }

        .profile-default-button {
          width: 40%;
        }
      }

      input, span {
        margin-right: 10px;
        margin-left: 10px;
      }

      span {
        font-size: 16px;
        font-weight: 600;
      }
    }

    .image-crop-container {
      display: flex;
      justify-content: center;
      background: rgba(0, 0, 0, 0.6);
      width: 100%;
      max-height: 425px;

      .ReactCrop__image {
        max-height: 425px !important;
        width: 100%;
      }
    }
  }
}
